
import Vue, { watch } from "vue";
import notifications from "@/lib/notifications";
import Component from "vue-class-component";
import SystemModule from "@/store/modules/system";
import { getModule } from "vuex-module-decorators";
import { Watch } from "vue-property-decorator";

const systemModule = getModule(SystemModule);

interface NodeStructure {
  id: string;
  displayName: string;
  description: string;
  children: NodeStructure[] | null;
  isOpen: boolean;
  hasMatch: boolean;
  permission: any;
}

@Component
export default class RoleEdit extends Vue {
  loadingPage: boolean = false;
  loading: boolean = false;
  roleDetail: any = {
    id: null,
    name: null,
    isAgentRole: false,
    permissions: null
  };
  searchCriteria ="";
  rolePermissions: NodeStructure[] = [];
  permissionHtml: string = "";
  currentSection: any = [null, null, null, null, null];

  toggleSelection(node: NodeStructure) {
    node.permission.allowed = !node.permission.allowed;
  }

  clearAll(node: NodeStructure) {
    if(node == null)
      return;

      node.children.forEach(e => {
        e.permission.allowed = false;
        this.clearAll(e);
      })
    }

  selectAll(node: NodeStructure) {
    if(node == null)
      return;
    node.children.forEach(e => {
      e.permission.allowed = true;
      this.selectAll(e);
    })
  }

  async created() {
    if (this.$route.params.id) this.loadingPage = true;
    this.roleDetail = await systemModule.getRoleDetail(+this.$route.params.id);
    this.roleDetail.permissions = this.roleDetail.permissions.sort( (a, b) => (a.systemName > b.systemName) ? 1 : -1)
    
    this.currentSection = [null, null, null, null, null];
    this.processNode(0, this.rolePermissions, '');

    this.loadingPage = false;
  }


  folderToggle(node: NodeStructure) {
    node.isOpen = !node.isOpen
  }

  @Watch("searchCriteria")
  searchCriteriaChanged(newVal, oldVal) {
    this.rolePermissions = [];
    this.currentSection = [null, null, null, null, null];
    this.processNode(0, this.rolePermissions, '');
  }

  processNode(level: number, nodeObj: any, parentPath: string): boolean {
    let hasMatch = false;

    if(this.roleDetail === null || this.roleDetail.permissions === null)
      return hasMatch;

    if(level > 6)
      return hasMatch;

      this.roleDetail.permissions.forEach( e => {
        if(parentPath == '' || e.systemName.startsWith(parentPath)) {
          let nodes =  e.systemName.split('.');

          if(nodes[level] != this.currentSection[level]) {
            const newNode = {id: nodes[level], displayName: e.displayName || e.systemName, description: e.description, isOpen: false, permission: e, hasMatch: true, children: []}
            if(this.searchCriteria != null) {
              newNode.hasMatch = newNode.displayName.toUpperCase().indexOf(this.searchCriteria.toUpperCase())!=-1 || 
                newNode.permission.systemName.toUpperCase().indexOf(this.searchCriteria.toUpperCase())!=-1;
              if(newNode.hasMatch == true) {
                hasMatch = true;
              }
            }

            nodeObj.push(newNode);
            this.currentSection[level] = nodes[level];
            let results = this.processNode(level +1, newNode.children, parentPath+newNode.id+".");
            if(results) {
              newNode.isOpen = this.searchCriteria>'';
              newNode.hasMatch = true;
              hasMatch = true;
              // If this folder node is also itself a direct permission (e.g. "barcode.orders.view"
              // which is both a permission and a parent of "barcode.orders.view.itemgps"),
              // insert it as a leaf child so the template renders a checkbox for it.
              if (nodes.length === level + 1) {
                newNode.children.unshift({
                  id: newNode.id + '_self',
                  displayName: newNode.displayName,
                  description: newNode.description,
                  isOpen: false,
                  permission: e,
                  hasMatch: newNode.hasMatch,
                  children: null
                });
              }
            }
          }
        }
      });
      return hasMatch;
  }


  get isNew(): boolean {
    return this.roleDetail.id === null;
  }

  rowClicked(item) {
    item.allowed = !item.allowed;
  }

  async save() {
    let payload = {
      name: this.roleDetail.name,
      id: this.roleDetail.id,
      isAgentRole: this.roleDetail.isAgentRole,
      permissions: null
    };

    if (!this.isNew) {
      payload.permissions = this.roleDetail.permissions
        .filter(x => x.allowed)
        .map(y => y.systemName);
    }

    let executor = systemModule.updateRole;
    this.loading = true;
    let newId = null;

    try {
      if (this.isNew) {
        const response = await systemModule.createRole(payload);
        newId = response.id;
      } else {
        await systemModule.updateRole(payload);
      }
      notifications.success("Role saved", "Role changes saved");
      if (this.isNew) this.$router.push(`/admin/roles/${newId}`);
    } catch (ex) {
      notifications.error("Role not saved", "Failed to save changes");
    }

    this.loading = false;
  }
}
